import { DeleteFolder, FlimIcon } from "assets";
import { CustomButton } from "components";

interface ConfirmationDialogMsgProps {
  title: string;
  message: string;
  folderName?: string;
  error: string | null;
  onConfirm: (e: any) => void;
  onCancel: () => void;
  onVideo?: boolean;
}

const ConfirmationDialogMsg: React.FC<ConfirmationDialogMsgProps> = ({
  title,
  message,
  error,
  onConfirm,
  onCancel,
  folderName,
  onVideo
}) => {
  return (
    <>
      {" "}
      <div className="w-full text-center">
        <h2 className="text-2xl font-semibold mb-4">{title}</h2>
        <div className="w-full flex justify-center">
          <p className="w-fit flex justify-center rounded-lg p-2 bg-red-500 shadow-md">
            {onVideo ? <FlimIcon className="size-8 text-white " />: <DeleteFolder className="size-8 text-white " /> }
          </p>
        </div>
        <p className="font-bold text-sm mb-4">{folderName}</p>
        <p className="text-gray-700 mb-6 text-lg">{message}</p>
        {error && <span className="text-sm text-red-600">{error}</span>}
      </div>
      <div className="flex justify-between gap-4 mt-4 px-6">
        <CustomButton
          type="button"
          onClick={onCancel}
          className="bg-primary-500 text-white hover:bg-primary-900 hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out transform"
        >
          Cancel
        </CustomButton>
        <CustomButton
          type="button"
          onClick={onConfirm}
          className="bg-red-500 text-white hover:bg-red-900 hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out transform"
        >
          Confirm
        </CustomButton>
      </div>
    </>
  );
};

export default ConfirmationDialogMsg;
